import ContentTaskService from 'services/task/subServices/contentTask/ContentTaskService';

export default {
	'services.contentTaskService': {
		class: ContentTaskService,
		deps: [{ $ref: 'services.taskStateService' }, { $ref: 'services.contentBlocksService' }],
	},
};
